var moment = require('moment-timezone');

var WaitListAppointmentsServicesModel = require('./appointment-service');
var GuestServiceModel = require('../../../shared/app/models/booking/guest-service-model');

var WaitListAppointmentsModel = Backbone.Epoxy.Model.extend({
  initialize: function() {
    this.on('change:smsOptIn', _.bind(this.onOptInChanged, this));
    this.on('change:smsMarketingOptIn', _.bind(this.onMarketingOptInChanged, this))
  },

  defaults: {
    waitListAppointmentId: null,
    waitListAppointmentUuid: null,
    statusInService: false,
    expectedWaitTimeMins: null,
    suggestedArrivalTime: null,
    estimatedServiceTime: null,
    currentWaitTime: null,
    enteredWaitListAt: 0,
    store: {},
    isWaitBoardLinkEnabled: false,
    services: new Backbone.Collection(null, { model: WaitListAppointmentsServicesModel }),
    guestServiceCollection: new Backbone.Collection(null, {model: GuestServiceModel}),
    hasGuests: false,
    mainGuestName: null,
    mainGuestPhone: null,
    mainGuestZipcode: null,
    mainGuest: null,
    isGuestOnlyCheckin: false,
    smsOptIn: false,
    smsMarketingOptIn: false
  },

  computeds: {
    storeHasPhone: function() {
      return this.get('store') && this.get('store').phone != null;
    },
    storeGetPhone: function() {
      return this.get('storeHasPhone') ? this.get('store').phone : null;
    },

    storeHasEmail: function() {
      return this.get('store') && this.get('store').email != null;
    },
    storeGetEmail: function() {
      return this.get('storeHasEmail') ? this.get('store').email : null;
    },
    storeGetEmailFull: function() {
      return this.get('storeHasEmail') ? 'mailto:' + this.get('store').email : null;
    },

    storeHasWebsite: function() {
      return this.get('store') && this.get('store').website != null;
    },
    storeGetWebsite: function() {
      return this.get('storeHasWebsite') ? this.get('store').website : null;
    },

    storeHasPhotoId: function() {
      return this.get('store') && this.get('store').photoId != null;
    },
    storeGetPhotoId: function() {
      return this.get('storeHasPhotoId') ? this.get('store').photoId : null;
    },

    storeHasName: function() {
      return this.get('store') && this.get('store').name != null;
    },
    storeGetName: function() {
      return this.get('storeHasName') ? this.get('store').name : null;
    },

    storeHasAddress1: function() {
      return this.get('store') && this.get('store').address1 != null;
    },
    storeGetAddress1: function() {
      return this.get('storeHasAddress1') ? this.get('store').address1 : null;
    },

    storeHasAddress2: function() {
      return this.get('store') && this.get('store').address2 != null;
    },
    storeGetAddress2: function() {
      return this.get('storeHasAddress2') ? this.get('store').address2 : null;
    },

    storeGetGmapsHref: function() {
      var params = $.param({ daddr: this.get('store').address1 + ' ' + this.get('store').address2 });
      return "https://maps.google.com?" + params;
    },

    storeGetNumRatings: function() {
      return this.get('store') && this.get('store').numRatings != null ? this.get('store').numRatings : 0;
    },

    storeGetAvRating: function() {
      return this.get('store') && this.get('store').avgRating != null ? this.get('store').avgRating : 0;
    },

    storeHasFacebookUrl: function() {
      return this.get('store') && this.get('store').facebookUrl != null;
    },
    storeGetFacebookUrl: function() {
      return this.get('storeHasFacebookUrl') ? this.get('store').facebookUrl : null;
    },

    storeHasGPlusUrl: function() {
      return this.get('store') && this.get('store').googlePlusUrl != null;
    },
    storeGetGPlusUrl: function() {
      return this.get('storeHasGPlusUrl') ? this.get('store').googlePlusUrl : null;
    },

    storeHasTwitterUrl: function() {
      return this.get('store') && this.get('store').twitterUrl != null;
    },
    storeGetTwitterUrl: function() {
      return this.get('storeHasTwitterUrl') ? this.get('store').twitterUrl : null;
    },

    storeHasYelpUrl: function() {
      return this.get('store') && this.get('store').yelpUrl != null;
    },
    storeGetYelpUrl: function() {
      return this.get('storeGetYelpUrl') ? this.get('store').yelpUrl : null;
    },

    storeGetGmapsAddress: function() {
      var params = $.param({ daddr: this.get('store').address1 + ' ' + this.get('store').address2 });
      return "https://maps.google.com?" + params;
    },

    storeTimeZone: function() {
      return this.get('store').timezone;
    },

    suggestedArrivalTimeString: {
      deps:['suggestedArrivalTime'],
      get: function(suggestedArrivalTime) {
        return bookedby.helpers.timeFormat(suggestedArrivalTime);
      }
    }
  },

  validation: { },

  onOptInChanged: function() {
    if (this.bindingData) {
      return;
    }

    bookedby.app.updateCurrentClientOptIn(this.get('smsOptIn'))
      .then(function() {
        //Nothing
      }).fail(_.bind(function() {
        this.bindingData = true;
        this.set('smsOptIn', bookedby.app.getCurrentClient().get('smsOptIn'));
        this.bindingData = false;
      }, this))
  },

  onMarketingOptInChanged: function() {
    if (this.bindingData) {
      return;
    }
    bookedby.app.updateCurrentClientMarketingOptIn(this.get('smsMarketingOptIn'), this.get('store')?this.get('store').storeId: null)
      .then(function() {
        //Nothing
      }).fail(_.bind(function() {
        this.bindingData = true;
        this.set('smsMarketingOptIn', bookedby.app.getCurrentClient().get('smsMarketingOptIn'));
        this.bindingData = false;
      }, this))
  },

  getWaitBoardField: function(waitListPart, fieldName, defaultValue) {
    var waitBoardEnabled = this.get('isWaitBoardLinkEnabled');

    if (! waitBoardEnabled) {
      return defaultValue;
    }

    if (_.has(waitListPart, fieldName)) {
      return waitListPart[fieldName];
    } else {
      return defaultValue;
    }
  },

  bindWaitListEntry: function(waitListInfo, waitBoardInfo) {
    this.bindingData = true;

    this.set('store', {
      storeId: waitListInfo.store.id,
      name: waitListInfo.store.name,
      address1: waitListInfo.store.address1,
      address2: waitListInfo.store.address2,
      phone: waitListInfo.store.phone,
      email: waitListInfo.store.email,
      website: waitListInfo.store.website,
      numRatings: waitListInfo.store.numRatings,
      avgRating: waitListInfo.store.avgRating % 1 == 0.5 ? waitListInfo.store.avgRating : Math.round(waitListInfo.store.avgRating),
      facebookUrl: waitListInfo.store.facebookUrl,
      googlePlusUrl: waitListInfo.store.googlePlusUrl,
      twitterUrl: waitListInfo.store.twitterUrl,
      yelpUrl: waitListInfo.store.yelpUrl,
      photoId: waitListInfo.store.photoId,
      timezone: waitListInfo.store.timeZone,
      storeLocalTime: waitListInfo.store.storeLocalTime
    });
    this.set('isWaitBoardLinkEnabled', ((waitBoardInfo || {}).settings || {}).enabled);

    if (bookedby.app.getCurrentClient() != null) {
      this.set('smsOptIn', bookedby.app.getCurrentClient().get('smsOptIn'));
      this.set('smsMarketingOptIn', bookedby.app.getCurrentClient().get('smsMarketingOptIn'));
    }
    this.set('isGuestOnlyCheckin', waitListInfo.isGuestOnlyCheckin);
    this.set('waitListAppointmentId', waitListInfo.id);
    this.set('waitListAppointmentUuid', waitListInfo.uuid);
    this.set('statusInService',      this.getWaitBoardField(waitListInfo, 'statusInService',      false));
    this.set('expectedWaitTimeMins', this.getWaitBoardField(waitListInfo, 'expectedWaitTimeMins', null));
    this.set('estimatedServiceTime', waitListInfo.estimatedServiceTime);
    this.set('suggestedArrivalTime', waitListInfo.suggestedArrivalTime);
    this.set('currentWaitTime', moment(this.get('store').storeLocalTime).tz(this.get('store').timezone));
    this.set('enteredWaitListAt', waitListInfo.enteredWaitListAt);

    this.set('mainGuestName', waitListInfo.client.firstName + ' ' + waitListInfo.client.lastName);
    this.set('mainGuestPhone', waitListInfo.client.phone);
    this.set('mainGuestZipcode', waitListInfo.client.zipCode);
    this.set('mainGuestEmail', waitListInfo.client.email);

    this.get('services').reset();

    var staticStore = _.find(bookedby.staticData.stores, _.bind(function(store) {
      return store.id == waitListInfo.store.id;
    }, this));

    var index = 1;
    var serviceModel = null;
    _.each(waitListInfo.services, _.bind(function(service) {
      if (!service.isAddon) {
        serviceModel = new WaitListAppointmentsServicesModel();

        serviceModel.set('index', index);
        serviceModel.set('serviceId', service.storeServiceId);
        serviceModel.set('centralServiceId', service.centralServiceId);
        serviceModel.set('serviceName', service.name);
        serviceModel.set('employeeId', service.employeeId);
        serviceModel.set('photoId', service.Employee ? service.Employee.photoId : null);
        serviceModel.set('employeeName', service.Employee ? service.Employee.displayName : null);
        serviceModel.set('showPrice', waitListInfo.store.showPrices);
        serviceModel.set('showDuration', waitListInfo.store.showDurations);
        serviceModel.set('minPrice', waitListInfo.store.showPrices ? service.minPrice : 0);
        serviceModel.set('maxPrice', waitListInfo.store.showPrices ? service.maxPrice : 0);
        serviceModel.set('minDuration', waitListInfo.store.showDurations ? service.minDuration : 0);
        serviceModel.set('maxDuration', waitListInfo.store.showDurations ? service.maxDuration : 0);
        serviceModel.set('minPrice', service.minPrice);
        serviceModel.set('maxPrice', service.maxPrice);
        serviceModel.set('minDuration', service.minDuration);
        serviceModel.set('maxDuration', service.maxDuration);
        serviceModel.set('addons', []);
        serviceModel.set('clientId', waitListInfo.clientId);
        serviceModel.set('firstName', waitListInfo.client.firstName);
        serviceModel.set('lastName', waitListInfo.client.lastName);

        if (!service.Employee) {
          serviceModel.set('isFirstAvailable', true);
        }

        this.get('services').push(serviceModel);

        index++;
      } else {
        // push this addon to the last known instance of serviceModel since it is ordered and the parent
        serviceModel.set('minPrice', waitListInfo.store.showPrices ? (serviceModel.get('minPrice') + service.minPrice) : 0);
        serviceModel.set('maxPrice', waitListInfo.store.showPrices ? (serviceModel.get('maxPrice') + service.maxPrice) : 0);
        serviceModel.set('minDuration', waitListInfo.store.showDurations ? (serviceModel.get('minDuration') + service.minDuration) : 0);
        serviceModel.set('maxDuration', waitListInfo.store.showDurations ? (serviceModel.get('maxDuration') + service.maxDuration) : 0);

        serviceModel.get('addons').push({
          serviceId: service.storeServiceId,
          centralServiceId: service.centralServiceId,
          serviceName: service.name,
          minPrice: service.minPrice,
          maxPrice: service.maxPrice,
          minDuration: service.minDuration,
          maxDuration: service.maxDuration
        });

        serviceModel.initComputeds();
      }
    }, this));

    var index = 0;
    var guestAppointmentsModels = [];
    if (waitListInfo.isGuestOnlyCheckin) {
      // NOTE: Show primaryClient as guest
      guestAppointmentsModels.push(new GuestServiceModel({
        index: index,
        totalEstimatedTime: waitListInfo.estimatedServiceTime,
        employee: waitListInfo.services[0].Employee,
        service: bookedby.app.serviceManager.serviceMap[waitListInfo.services[0].centralServiceId],
        firstName: waitListInfo.client.firstName,
        lastName: waitListInfo.client.lastName,
        phone: waitListInfo.client.phone,
        statusInService:      this.getWaitBoardField(waitListInfo, 'statusInService',      false),
        expectedWaitTimeMins: this.getWaitBoardField(waitListInfo, 'expectedWaitTimeMins', null),
        enteredWaitListAt: waitListInfo.enteredWaitListAt,
        estimatedServiceTime: waitListInfo.estimatedServiceTime,
        suggestedArrivalTime: waitListInfo.suggestedArrivalTime,
        currentWaitTime: moment(this.get('store').storeLocalTime).tz(this.get('store').timezone),
        parentModel: this
      }));
      index++;
    }
    _.each(waitListInfo.guestServices, _.bind(function(guestService) {
      var guestModel = new GuestServiceModel({
        index: index,
        totalEstimatedTime: guestService.estimatedServiceTime,
        employee: guestService.services[0].Employee,
        service: bookedby.app.serviceManager.serviceMap[guestService.services[0].centralServiceId],
        firstName: guestService.Client.firstName,
        lastName: guestService.Client.lastName,
        phone: guestService.Client.phone1,
        statusInService:      this.getWaitBoardField(guestService, 'statusInService',      false),
        expectedWaitTimeMins: this.getWaitBoardField(guestService, 'expectedWaitTimeMins', null),
        enteredWaitListAt: guestService.enteredWaitListAt,
        estimatedServiceTime: guestService.estimatedServiceTime,
        suggestedArrivalTime: guestService.suggestedArrivalTime,
        currentWaitTime: moment(this.get('store').storeLocalTime).tz(this.get('store').timezone),
        parentModel: this
      });
      guestAppointmentsModels.push(guestModel);
      index++;
    }, this));

    this.get('guestServiceCollection').reset(guestAppointmentsModels);

    this.set('hasGuests', this.get('guestServiceCollection').length > 0);

    this.bindingData = false;
  },

  getWaitTimeToArrival: function() {
    var expectedWaitTimeMins = this.get('expectedWaitTimeMins');
    if (!_.isNull(expectedWaitTimeMins)) {
      return expectedWaitTimeMins;
    }

    if (!this.get('currentWaitTime')) {
      return 0;
    }

    if (this.get('waitListAppointmentId') != null) {
      var serviceTime = bookedby.helpers.getNewMomentWithTimeOfDayBySecond(moment().tz(this.get('store').timezone), this.get('estimatedServiceTime'));
      var enteredTime = bookedby.helpers.getNewMomentWithTimeOfDayBySecond(moment().tz(this.get('store').timezone), this.get('enteredWaitListAt'));

      var waitTime = serviceTime.diff(enteredTime, 's');

      if (waitTime < 0) {
        waitTime = 0;
      }

      this.get('currentWaitTime').add(30, 's');

      return bookedby.helpers.secondsToMinutesRoundable(waitTime, 1); //bookedby.helpers.timeToDuration(waitTime).totalMinutes;
    } else {
      return 0;
    }

  }
});

module.exports = WaitListAppointmentsModel;
